import { render, staticRenderFns } from "./GroupSearch.vue?vue&type=template&id=0aac900c&"
import script from "./GroupSearch.controller.js?vue&type=script&lang=js&"
export * from "./GroupSearch.controller.js?vue&type=script&lang=js&"
import style0 from "./GroupSearch.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports